import service from '../../utils/request'


const getIndexInfo = () => {
    return service({
        url: 'api/toIndex',
        method: 'get',
        
    })
}
// 免费课点击更多
const getFreeCourseList = (page) => {
    return service({
        url: `api/course/getFreeCourseList?pageNo=${page}`,
        method: 'get',
        
    })
}
// 精品课课程列表
const getPaidCourseList = (page) => {
    return service({
        url: `api/course/getPaidCourseList?pageNo=${page}`,
        method: 'get',
        
    })
}

export {
    getIndexInfo,
    getFreeCourseList,
    getPaidCourseList
}